import { GALLERY_FILES } from '../../marketplace-custom-config';

const getGalleryDocumentsDictionary = assets =>
    assets.reduce((acc, item) => ({ ...acc, [item.Key]: { ...item, ...item.metadata } }), {});

export const handleGalleryImageArrangement = ({
    images,
    assets,
    entityId,
    onChangeEntityAssetMetadata,
}) => {
    const galleryDocumentsDictionary = getGalleryDocumentsDictionary(assets);

    return Promise.all(
        images.map(async (image, index) => {
            const Key = image.id.uuid;

            const {
                position,
                description,
                gallerytype,
                type,
                originalname,
                mimetype,
            } = galleryDocumentsDictionary[Key];

            if (Number(position) !== index) {
                const isSuccessful = await onChangeEntityAssetMetadata({
                    idToUpdate: Key,
                    id: entityId, // listingId,
                    metadata: {
                        description,
                        gallerytype,
                        type,
                        position: String(index),
                        originalname,
                        mimetype,
                    },
                });

                if (!isSuccessful) {
                    throw new Error();
                }
            }
        })
    );
};

export const handleRotateImage = async ({
    image,
    entityId,
    onAssetsRequest,
    onRequestToRotateEntityImage,
    rotateAngle = 90,
}) => {
    const isSuccessful = await onRequestToRotateEntityImage({
        idToUpdate: image.id.uuid,
        id: entityId,
        rotateAngle,
    });

    if (isSuccessful) {
        onAssetsRequest(entityId);
    }

    return isSuccessful;
};

export const handleChangeImageDescription = async ({
    image,
    entityId,
    description,
    onAssetsRequest,
    onChangeEntityAssetMetadata,
}) => {
    const { position, gallerytype, originalname, mimetype, __type } = image;

    const isSuccessful = await onChangeEntityAssetMetadata({
        idToUpdate: image.id.uuid,
        id: entityId,
        metadata: {
            description: btoa(description),
            gallerytype,
            type: __type,
            position: String(position),
            originalname,
            mimetype,
        },
    });

    if (isSuccessful) {
        onAssetsRequest(entityId);
    }
};
